'use client';

import { useAuthStore } from '@/store/useAuthStore';
import { api } from '@/lib/api';
import { useToast } from '@/components/ui/toast';
import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { useCooldown } from '@/lib/hooks/useCooldown';
import { useState } from 'react';

export function EmailVerificationBanner() {
  const { user } = useAuthStore();
  const { addToast } = useToast();
  const [resending, setResending] = useState(false);
  const { remaining, start, isActive } = useCooldown(60);

  // Don't show if no user or email is verified
  if (!user || !user.email || user.emailVerifiedAt) {
    return null;
  }

  const handleResend = async () => {
    if (!user.email) return;

    setResending(true);
    try {
      await api.auth.resendVerification(user.email);
      start(); // Start cooldown timer
      addToast({
        title: 'Имэйл илгээсэн',
        description: 'Хэрэв бүртгэл байвал баталгаажуулах имэйл илгээсэн',
      });
    } catch (err: any) {
      addToast({
        title: 'Алдаа',
        description: err.message || 'Баталгаажуулах имэйл илгээхэд алдаа гарлаа',
        variant: 'destructive',
      });
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="bg-yellow-50 border-b border-yellow-200 px-4 py-2">
      <div className="container mx-auto max-w-7xl flex items-center justify-between gap-4">
        <div className="flex-1 flex items-center gap-3">
          <p className="text-sm text-yellow-800">
            <strong>Имэйлээ баталгаажуулна уу</strong> бүх функцийг идэвхжүүлэхийн тулд
          </p>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handleResend}
              disabled={resending || isActive}
              className="h-7 text-xs border-yellow-300 text-yellow-800 hover:bg-yellow-100"
            >
              {resending
                ? 'Илгээж байна...'
                : isActive
                ? `Имэйл дахин илгээх (${remaining}с)`
                : 'Имэйл дахин илгээх'}
            </Button>
            <Link href={`/check-email?email=${encodeURIComponent(user.email)}`}>
              <Button
                variant="ghost"
                size="sm"
                className="h-7 text-xs text-yellow-800 hover:bg-yellow-100"
              >
                Баталгаажуулах хуудас нээх
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

